import { render, staticRenderFns } from "./triggers.vue?vue&type=template&id=460a6777&"
import script from "./triggers.vue?vue&type=script&lang=js&"
export * from "./triggers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports